export default __webpack_public_path__ + "static/media/8THERE_SALOTTOUNPACK.5d63738e.mp3";